import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import * as moment from 'moment';

@Injectable()
export class UtcDateAdapterService extends NativeDateAdapter {

  override parse(value: any): Date | null {
    if ((typeof value === 'string') && value.trim().length > 0) {
      // Parse string as UTC
      return moment.utc(value, 'YYYY-MM-DD HH:mm:ss').toDate();
    }
    return value ? new Date(value) : null;
  }

  override format(date: Date, displayFormat: Object): string {
    if (!date) return '';
    // Always format in UTC
    return moment.utc(date).format('YYYY-MM-DD HH:mm:ss');
  }
}
